require('./dropdownInterveners.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @ commons
const { formatText} = require('core/i18n').i18n;

const OKSelect = require('components/commons/OKSelect/OKSelect');

// @ components
const IntervenerItemSelected = require('components/contactCenter/dropdownInterveners/intervenerItemSelected');
const IntervenerItemOptions = require('components/contactCenter/dropdownInterveners/intervenerItemOptions');

// @ utilities
const { getIntervenerIdFromValue, getValueFromIntervenerId, isEmptyIntervenerId } = require('utilities/contactCenter/dropdownIntervenersHelper');

class DropdownInterveners extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { initialIntervenerId, currentIntervenerId } = this.props;

        if (initialIntervenerId && isEmptyIntervenerId(currentIntervenerId)) {
            this.props.onIntervenerChange(initialIntervenerId, true);
        }
    }

    handleChange(item) {
        this.props.onIntervenerChange(getIntervenerIdFromValue(item.value));
    }

    handleBlur() {
        const { currentIntervenerId, onIntervenerChange } = this.props;

        if (isEmptyIntervenerId(currentIntervenerId)) {
            onIntervenerChange({});
        }
    }

    render() {
        const {
            immInterveners,
            currentIntervenerId,
            enabled,
            id,
            error,
            errorMsg,
            label,
            placeholder
        } = this.props;

        let options = immInterveners.toJS();

        options = options.map(intervener => {
            return {
                id,
                value: getValueFromIntervenerId(intervener.intervenerId),
                name: intervener.intervenerName,
                interventionType: intervener.interventionType
            }
        });

        return (
            <OKSelect
                id={id}
                label={label}
                name="form-field-name"
                className={classnames('dropdown-interveners', {'dropdown-interveners--error' : error})}
                disabled={!enabled}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                optionComponent={IntervenerItemOptions}
                options={options}
                value={getValueFromIntervenerId(currentIntervenerId)}
                valueComponent={IntervenerItemSelected}
                searchable={false}
                clearable={false}
                placeholder={placeholder}
                errorState={error}
                errorMessage={errorMsg}
            />
        );
    }
}

DropdownInterveners.propTypes = {
    currentIntervenerId: PropTypes.object,
    initialIntervenerId: PropTypes.object,
    onIntervenerChange: PropTypes.func,
    enabled: PropTypes.bool,
    immInterveners: PropTypes.object,
    id: PropTypes.string,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string
};

DropdownInterveners.defaultProps = {
    enabled: true,
    errorMsg: '',
    label: '',
    placeholder: formatText('dropdownInterveners-selectIntervener')
}
module.exports = DropdownInterveners;
